import { ButtonProps, DialogDescription, Heading } from "@chakra-ui/react";

import { RoundedButton } from "@/components/rounded-button";
import { SeasonStatsCard } from "@/components/season-stats-card";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTrigger,
} from "@/components/ui/dialog";

export const SeasonStatsModal = (buttonStyleProps: ButtonProps) => {
  return (
    <DialogRoot size="sm">
      <DialogTrigger asChild>
        <RoundedButton variant="outline" {...buttonStyleProps}>
          Season 1 Stats
        </RoundedButton>
      </DialogTrigger>
      <DialogContent p={4}>
        <DialogHeader display="unset">
          <Heading size="3xl" textAlign="center" mb={2}>
            Season 1
          </Heading>
          <DialogDescription fontSize="md" textAlign="center">
            Thank you for participating in Plume Testnet
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <SeasonStatsCard showProfile />
        </DialogBody>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};
